import type { ComponentProps } from 'react'

import { Toast } from '@base-ui/react'
import { IconX } from '@tabler/icons-react'
import styled from 'styled-components'

const CloseButton = styled.button`
	align-items: center;
	background: transparent;
	border: 0;
	border-radius: ${({ theme }) => theme.borderRadius};
	color: ${({ theme }) => theme.color.textContrast};
	cursor: pointer;
	display: flex;
	height: 26px;
	justify-content: center;
	padding: 0;
	width: 26px;

	&:hover {
		background: rgba(255, 255, 255, 0.1);
		color: ${({ theme }) => theme.color.danger};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.color.textContrast};
		outline-offset: 2px;
	}
`

type Props = ComponentProps<typeof Toast.Close>

export const ButtonClose = ({ ...rest }: Props) => (
	<Toast.Close
		{...rest}
		render={(props) => (
			<CloseButton {...props} aria-label='Dismiss notification' type='button'>
				<IconX size={20} />
			</CloseButton>
		)}
	/>
)
